/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Grid: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path d='M23 11V3C23 2.46957 22.7893 1.96086 22.4142 1.58579C22.0391 1.21071 21.5304 1 21 1H13V11H23Z' fill='currentColor' />
    <path d='M11 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V11H11V1Z' fill='currentColor' />
    <path d='M1 13V21C1 21.5304 1.21071 22.0391 1.58579 22.4142C1.96086 22.7893 2.46957 23 3 23H11V13H1Z' fill='currentColor' />
    <path d='M13 23H21C21.5304 23 22.0391 22.7893 22.4142 22.4142C22.7893 22.0391 23 21.5304 23 21V13H13V23Z' fill='currentColor' />
  </React.Fragment>
)
